import { useActiveOrganizationMembers } from '@/Pages/Settings/utils/useMembers';
import { IdentitySchema } from '@/types/schema';

import { useAuth } from './useAuth/useAuth';

const userPredicate = (user?: IdentitySchema, userId?: string) =>
  user?.user_id === userId ||
  user?.linked_login_methods?.some(
    (login) => login.provider_user_id === userId
  );

export function useFeedbackSourceUser(feedbackUserId: string) {
  const { session } = useAuth();
  const userIds = [feedbackUserId];

  const sessionId = session?.user.id;
  if (sessionId) {
    userIds.push(sessionId);
  }

  const { data: orgUsers, isLoading } = useActiveOrganizationMembers({
    user_ids: userIds,
    offset: 0,
    limit: 100,
  });

  const feedbackUser = orgUsers?.find((user) =>
    userPredicate(user, feedbackUserId)
  );

  const isActiveUser = userPredicate(feedbackUser, sessionId);

  return {
    isActiveUser,
    feedbackUser,
    isLoading,
  };
}
